import "core-js/modules/es.array.fill.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
export function HappyFaceIcon(props) {
  var _props$fill, _props$fill2, _props$fill3, _props$fill4;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": t('ARIA_LABEL_HAPPY_FACE'),
    "data-testid": "happy-face-icon",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24 0C10.7666 0 0 10.7666 0 24C0 37.2334 10.7666 48 24 48C37.2334 48 48 37.2334 48 24C48 10.7666 37.2334 0 24 0ZM24 45.913C11.9165 45.913 2.08696 36.0835 2.08696 24C2.08696 11.9165 11.9165 2.08696 24 2.08696C36.0835 2.08696 45.913 11.9165 45.913 24C45.913 36.0835 36.0835 45.913 24 45.913Z",
      fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : 'black'
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.7826 19.826C18.7826 18.1001 17.3781 16.6956 15.6522 16.6956C13.9262 16.6956 12.5217 18.1001 12.5217 19.826C12.5217 21.5519 13.9262 22.9564 15.6522 22.9564C17.3781 22.9564 18.7826 21.5519 18.7826 19.826ZM14.6087 19.826C14.6087 19.251 15.0772 18.7825 15.6522 18.7825C16.2271 18.7825 16.6956 19.251 16.6956 19.826C16.6956 20.4009 16.2271 20.8695 15.6522 20.8695C15.0772 20.8695 14.6087 20.4009 14.6087 19.826Z",
      fill: (_props$fill2 = props.fill) !== null && _props$fill2 !== void 0 ? _props$fill2 : 'black'
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.3478 16.6956C30.6219 16.6956 29.2174 18.1001 29.2174 19.826C29.2174 21.5519 30.6219 22.9564 32.3478 22.9564C34.0737 22.9564 35.4783 21.5519 35.4783 19.826C35.4783 18.1001 34.0737 16.6956 32.3478 16.6956ZM32.3478 20.8695C31.7729 20.8695 31.3044 20.4009 31.3044 19.826C31.3044 19.251 31.7729 18.7825 32.3478 18.7825C32.9228 18.7825 33.3913 19.251 33.3913 19.826C33.3913 20.4009 32.9228 20.8695 32.3478 20.8695Z",
      fill: (_props$fill3 = props.fill) !== null && _props$fill3 !== void 0 ? _props$fill3 : 'black'
    }), /*#__PURE__*/_jsx("path", {
      d: "M34.0873 29.4834C33.6574 29.0984 32.9969 29.136 32.6139 29.5648C30.4372 31.9972 27.2984 33.3913 24 33.3913C20.7026 33.3913 17.5628 31.9972 15.3861 29.5648C15.001 29.136 14.3426 29.0984 13.9127 29.4834C13.4828 29.8674 13.4473 30.5269 13.8313 30.9568C16.4035 33.8306 20.1099 35.4782 24 35.4782C27.8911 35.4782 31.5976 33.8295 34.1687 30.9568C34.5527 30.5269 34.5162 29.8674 34.0873 29.4834Z",
      fill: (_props$fill4 = props.fill) !== null && _props$fill4 !== void 0 ? _props$fill4 : 'black'
    })]
  });
}